/**
 * 말이 올라가는 속도 (SPEC_CHANGE_v1.3 31장, C-37 · DEV-07z2 · D100). 서버(공개 큐)와 화면(순차 공개)이 같은 값을 씁니다.
 *
 * - 다음 말 간격 = max(앞 말 글자 수 × 50ms, 올릴 말 글자 수 × 45ms), 1.5 ~ 4초. 읽을 시간과 입력 중을 겹침(더하지 않음)
 * - 앞 말이 보이고 0.4초 뒤부터 다음 멤버 「입력 중」. 빈 화면은 그 0.4초뿐
 * - 같은 멤버 연속 말풍선(카운터 이모 등): 0.8 ~ 1.2초(입력 중은 짧게)
 * - 생성 없이 바로 올리는 첫 말(대본 · 카운터 · 1:1 덧붙는 말): 이미 흐른 시간을 빼고 남은 몫, 최소 0.8초
 * - 「말 속도」(어드민, 0.8 · 1.0 · 1.3배, 기본 1.0)를 모든 시간에 곱함. 위기 답은 이 간격을 쓰지 않고 즉시
 */

export const READ_MS_PER_CHAR = 50;
export const TYPE_MS_PER_CHAR = 45;
export const GAP_MIN_MS = 1500;
export const GAP_MAX_MS = 4000;
export const TYPING_LEAD_MS = 400;
export const SAME_MEMBER_GAP_MS = [800, 1200];
export const FIRST_MIN_MS = 800;
export const REVEAL_SPEEDS = [0.8, 1, 1.3];
export const DEFAULT_REVEAL_SPEED = 1;
export const REVEAL_SPEED_SETTING = 'reveal_speed';

function charCount(text) {
    return Array.from(String(text ?? '').replace(/\s+/gu, '')).length;
}

/** 어드민이 고른 배수만 받음(모르면 기본) */
export function normalizeSpeed(speed) {
    const value = Number(speed);
    return REVEAL_SPEEDS.includes(value) ? value : DEFAULT_REVEAL_SPEED;
}

/**
 * 앞 말이 보인 때부터 다음 말을 올릴 때까지(ms)
 * @param {{ prevBody?: string, nextBody?: string, sameMember?: boolean, speed?: number, random?: () => number }} input
 */
export function revealGapMs({ prevBody = '', nextBody = '', sameMember = false, speed = 1, random = Math.random }) {
    const factor = normalizeSpeed(speed);
    if (sameMember) {
        const [low, high] = SAME_MEMBER_GAP_MS;
        return Math.round((low + random() * (high - low)) * factor);
    }
    const raw = Math.max(charCount(prevBody) * READ_MS_PER_CHAR, charCount(nextBody) * TYPE_MS_PER_CHAR);
    return Math.round(Math.min(GAP_MAX_MS, Math.max(GAP_MIN_MS, raw)) * factor);
}

/** 앞 말이 보인 뒤 다음 「입력 중」을 띄우기까지(ms) */
export function typingLeadMs(speed = 1) {
    return Math.round(TYPING_LEAD_MS * normalizeSpeed(speed));
}

/** 생성 없이 올리는 첫 말: 이미 흐른 시간을 빼고 남은 몫(최소 0.8초) */
export function firstRevealWaitMs({ gapMs, elapsedMs = 0, speed = 1 }) {
    return Math.max(Math.round(FIRST_MIN_MS * normalizeSpeed(speed)), Math.round(gapMs - elapsedMs));
}
